<!-- Same arrangement as the AI assistant: the CONTAINER carries the 8-way resize handles (the
     directive attaches them to the enclosing `.cdk-overlay-pane`), and the HEADER is the drag
     handle. Both persist to the wizard's own layout key, so it reopens at the size and position
     it was left at. The frame around it is src/_cura-window.scss (panel class
     ai-recording-panel), which also paints the header and the actions.
     ⚠ The minimums are higher than the directive's defaults on purpose: the review surface below
     shows a coding-set diff with a code, a description and a status per row, and under roughly
     480px that wraps into something unreadable rather than merely small. -->
<div class="wizard-container"
     [appResizableOverlayPane]="layoutKey"
     [resizeMinWidth]="480"
     [resizeMinHeight]="420">

<div class="cw-header wizard-header" appDraggableOverlayPane [dragLayoutKey]="layoutKey">
    <mat-icon class="kind">rule</mat-icon>
    <div class="title">
        <span class="name">Review ICD-10 suggestions</span>
        <span class="subtitle">Before you {{ exportLabel }} - coding affects claim outcomes.</span>
    </div>
    <button mat-icon-button class="close" (click)="finish(false)" matTooltip="Close without exporting"
        aria-label="Close without exporting">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="wizard-progress">
    <span class="position">{{ index + 1 }} of {{ patients.length }}</span>
    <span class="patient-name">{{ currentName }}</span>
    <span class="patient-number" *ngIf="current?.patientNumber">({{ current?.patientNumber }})</span>

    <span class="spacer"></span>

    <!-- The queue often cannot be judged from the proposal alone. This routes underneath the
         wizard, which stays open because it is modeless. -->
    <button mat-stroked-button class="open-file quiet-button" (click)="openPatientFile()"
        matTooltip="Open this patient's file to read the notes. This wizard stays open.">
        <mat-icon>folder_open</mat-icon>
        Open patient file
    </button>
</div>

<div class="wizard-body">
    <!-- The review surface itself, embedded rather than reimplemented: it carries the coupling
         rules, the coding-set diff and the §7 rule 6 bulk guard. `setPatient()` repoints it as
         the wizard moves, so one instance serves the whole run. -->
    <!-- `queueCleared` fires only when a decision made here empties the queue, never on arrival,
         which is what lets finishing a patient move straight on to the next one. -->
    <app-icd-suggestions-dialog #review [embedded]="true"
        (queueCleared)="onQueueCleared($event)"></app-icd-suggestions-dialog>
</div>

<div class="wizard-footer cw-actions">
    <button mat-button class="quiet-button" (click)="previous()" [disabled]="isFirst">
        <mat-icon>chevron_left</mat-icon>
        Previous
    </button>

    <!-- A dot per patient, so progress through the set is visible without counting. -->
    <div class="dots">
        <!-- Filled once that patient's queue is empty. The one on screen updates live, so the dot
             fills as the last decision is resolved rather than when you move on. -->
        <button class="dot" *ngFor="let p of patients; let i = index" (click)="goTo(i)"
            [class.active]="i === index" [class.cleared]="isCleared(p)"
            [matTooltip]="(p.name || '') + ' ' + (p.surname || '')
                + (isCleared(p) ? ' — reviewed' : '')"></button>
    </div>

    <button mat-button class="quiet-button" (click)="next()" *ngIf="!isLast">
        Next
        <mat-icon>chevron_right</mat-icon>
    </button>

    <!-- Last patient, or every patient cleared (the run is often finished out of order): offer to
         run the export that was interrupted. -->
    <button mat-raised-button color="primary" class="tone-button" (click)="finish(true)" *ngIf="isLast || allCleared">
        Done - {{ exportLabel }} now
    </button>
</div>

</div>
